<template>
  <div>
    <List
      url="subscriber/subscriber/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      :useBatchSuffix="false"
      @edit="edit"
      @deletedata="deletedata"
      @batchPost="handleBatchDeleteSubscriberPost"
    >
    <div slot="Filter">
        <el-row :gutter="20">
          <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
            <el-button
              @click="add"
              type="primary"
              icon="el-icon-edit"
              >新增订阅者</el-button>
          </el-col>
        </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <span style="margin-right:5px;font-size:13px;">订阅者：</span>
        <el-select
          v-model="searchData.name"
          @change="search"
          size="small"
          filterable
          clearable
          placeholder="请选择订阅者"
          style="width:200px;margin-right:10px;">
          <el-option value="" label="全部"></el-option>
          <el-option
            v-for="name in subscriberNames"
            :key="name"
            :label="name"
            :value="name">
          </el-option>
        </el-select>

        <span style="margin-right:5px;font-size:13px;">是否订阅订Dis：</span>
        <el-select v-model="selectBusinessDisStatus" placeholder="选择Dis订阅状态" @change="search" style="width:120px;margin-right:10px;" size="small">
          <el-option value="全部" label="全部"></el-option>
          <el-option
            v-for="dis_business_subscription in businessDisStatus"
            :label="dis_business_subscription"
            :key="dis_business_subscription"
            :value="dis_business_subscription"></el-option>
        </el-select>

        <el-checkbox
          v-model="email_verified_at"
          @change="search"
          style="margin-right:10px;"
          size="small">
          仅显示未验证邮箱
        </el-checkbox>

        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>

      <template v-slot:slot-dis_business_subscription_display="scope">
        <el-switch
          v-model="scope.item.dis_business_subscription"
          :active-value="1"
          :inactive-value="0"
          active-color="#67C23A"
          @change="updateSubscription(scope.item)"
        ></el-switch>
      </template>

      <template v-slot:slot-template_type="scope">
        <el-tag :type="scope.item.template_type === 1 ? 'success' : 'danger'">
          {{ getTemplateTypeName(scope.item.template_type) }}
        </el-tag>
      </template>

      <template v-slot:slot-email_verified_at="scope">
        <template v-if="scope.item.email_verified_at === '待验证'">
          <el-tag type="danger" effect="plain" style="background-color: rgba(245, 108, 108, 0.1)">
            {{ scope.item.email_verified_at }}
          </el-tag>
        </template>
        <template v-else>
          {{ scope.item.email_verified_at }}
        </template>
      </template>

      <template v-slot:slot-email="scope">
        <div class="cell-wrap-content">
          {{ scope.item.email }}
        </div>
      </template>

      <template v-slot:slot-cc_email="scope">
        <div class="cell-wrap-content">
          {{ scope.item.cc_email }}
        </div>
      </template>

      <template v-slot:slot-bc_email="scope">
        <div class="cell-wrap-content">
          {{ scope.item.bc_email }}
        </div>
      </template>
    </List>
    <SubscriberUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      :clouds="cloudEnvList"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></SubscriberUpdateBox>
  </div>
</template>

<script>
import { HasStatus, SubscriberEmailTemplateTypes } from "../components/Index/data.js";

import List from "../components/common/List.vue";
import SubscriberUpdateBox from "../components/Subscriber/SubscriberUpdateBox.vue";

export default {
  components: {
    List,
    SubscriberUpdateBox
  },
  data() {
    return {
      dialogFormVisible: false,
      title: "订阅者",
      selectBusinessDisStatus: "全部",
      businessDisStatus: HasStatus,
      subscriberNames: [],
      emailTemplateTypes: SubscriberEmailTemplateTypes,
      tanle: [
        { name: "name", label: "订阅人" },
        { name: "email", label: "收件邮箱" },
        { name: "cc_email", label: "抄送邮箱" },
        { name: "bc_email", label: "密件抄送邮箱" },
        // { name: "email_verified_at", label: "邮箱验证时间" },
        { name: "dis_business_subscription_display", label: "是否订阅Dis业务数据" },
        { name: "template_type", label: "邮件通知模板类型" },
        { name: "remark", label: "备注" },
        { name: "updated", label: "修改时间" }
      ],
      searchData: {
        email: "",
        dis_business_subscription: "",
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchSubscriberNames();
  },
  methods: {
    dealList(data) {
      if (this.email_verified_at && Array.isArray(data)) {
        data = data.filter(item => !item.email_verified_at);
      }

      for (let i in data) {
        data[i].updated = this.changeDate(data[i].updated);
        data[i].email_verified_at = data[i].email_verified_at ? this.changeDate(data[i].email_verified_at) : '待验证';
        data[i].dis_business_subscription_display = data[i].dis_business_subscription ? "是" : "否";
      }
      return data;
    },
    close() {
      this.updateBlock = false;
      this.fetchSubscriberNames();
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateForm = {
        dis_business_subscription: "是",
        name: localStorage.getItem('username'),
        email: localStorage.getItem('email'),
        template_type: this.emailTemplateTypes[1].name,
      };
      this.updateType = "add";
      this.updateBlock = true;
    },
    search() {
      if (this.selectBusinessDisStatus === '全部') {
        this.searchData.dis_business_subscription = "";
      } else {
        this.searchData.dis_business_subscription = +(this.selectBusinessDisStatus === '是');
      };
      this.updateList++;
    },
    updateSubscription(item) {
      const params = {
        email: item.email,
        dis_business_subscription: typeof item.dis_business_subscription === 'string'
          ? (item.dis_business_subscription === "是" ? 1 : 0)
          : item.dis_business_subscription
      };

      const url = `subscriber/subscriber/${item.id}/`;

      this.$http["patch"](
        url,
        params,
        () => {
          this.$baseNotice.message("订阅状态更新成功");
          this.updateList++;
        },
        () => {
          this.$message({
            message: "订阅状态更新失败",
            type: "error"
          });
          // 恢复原值，避免UI显示与实际状态不一致
          item.dis_business_subscription = !item.dis_business_subscription;
        }
      );
    },
    deletedata(val) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = "subscriber/subscriber/" + val.id + "/";
        this.$http["delete"](url,
          () => {
            this.$baseNotice.message("删除成功");
            this.updateList++;
          },
          () => {
            this.$message({message: "删除失败", type: "error"});
          }
        );
      }).catch(() => {
        this.$message({message: "已取消删除", type: "warning"});
      });
    },
    getTemplateTypeName(value) {
      const template = this.emailTemplateTypes.find(t => t.value === value);
      return template ? template.name : '未知类型';
    },
    handleBatchDeleteSubscriberPost() {
      this.fetchSubscriberNames();
      this.updateList++;
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchSubscriberNames() {
      this.$http["get"](
        "subscriber/subscriber/", {}, (data) => {
          if (data && data.data && data.data.results) {
            this.subscriberNames = data.data.results.map(item => item.name);
          }
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

/* cc email 字段样式 */
.cell-wrap-content {
  white-space: pre-line;  // 换行后内容对齐
  word-break: break-word;
  max-width: 300px;
  padding: 8px 0;
  display: block;
  margin: 0;
}

/* 针对特定字段的单元格左对齐 */
/deep/ .el-table__row {
  td:nth-child(2) .cell,
  td:nth-child(3) .cell,
  td:nth-child(4) .cell,
  td:nth-child(5) .cell,
  td:nth-child(8) .cell
  {
    text-align: left !important;
  }
}
</style>
